import { configureStore } from "@reduxjs/toolkit";
import reducers from './slices';
import middlewares from "./middlewares";

const store = configureStore({
  reducer: reducers,
  devTools: process.env.NODE_ENV !== "production",
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(middlewares),
});

export type RootState = ReturnType<typeof store.getState>;
export default store;
